import { theme } from "@styles/themes/themes";
import * as React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "../../styles/css/globalstyle";
import { NormalizeStyle } from "../../styles/css/normalizestyle";
import { Footer, Header } from "../components";
import * as S from "./layout-component.style";
import { LayoutProps } from "./layout-component.types";

const LayoutComponent: React.FC<LayoutProps> = ({ children }) => {
	return (
		<div>
			<ThemeProvider theme={theme}>
				<NormalizeStyle />
				<GlobalStyle />
				<Header />
				<S.LayoutContainer>{children}</S.LayoutContainer>
				<Footer />
			</ThemeProvider>
		</div>
	);
};

export default LayoutComponent;
